import {
    Box,
    FormControl,
    ListItemIcon,
    ListItemText,
    MenuItem,
    Select,
    Typography,
} from "@mui/material";
import { DatosTablas } from "./DatosTablasClimaAero";
import {
    Air,
    Cloud,
    Thermostat,
    Visibility,
    WaterDrop,
    Speed,
    Thunderstorm,
    TableChart,
} from "@mui/icons-material";

const getIconForTable = (index) => {
    const icons = {
        0: <Thermostat sx={{ fontSize: 20 }} />,
        1: <WaterDrop sx={{ fontSize: 20 }} />,
        2: <Speed sx={{ fontSize: 20 }} />,
        3: <Thermostat sx={{ fontSize: 20 }} />,
        4: <Visibility sx={{ fontSize: 20 }} />,
        5: <Cloud sx={{ fontSize: 20 }} />,
        6: <Visibility sx={{ fontSize: 20 }} />,
        7: <Visibility sx={{ fontSize: 20 }} />,
        8: <Thunderstorm sx={{ fontSize: 20 }} />,
        9: <Visibility sx={{ fontSize: 20 }} />,
        10: <Air sx={{ fontSize: 20 }} />,
    };
    return icons[index] || <TableChart sx={{ fontSize: 20 }} />;
};

const SelectorTabla = function ({ onChange, idEstacion, tipoAnalisis, value }) {
    const tablasDisponibles = [];
    DatosTablas.titulosTablas.forEach((tablaTitulo, i) => {
        if (
            DatosTablas.tablasDisponiblesPorEstacion[idEstacion][i] &&
            DatosTablas.tipoTablas[i] === tipoAnalisis
        ) {
            tablasDisponibles.push({
                index: i,
                titulo: tablaTitulo,
                descripcion: DatosTablas.descripcionTablas[i],
            });
        }
    });

    const selectedTabla = tablasDisponibles.find((t) => t.index === value);

    return (
        <Box>
            <Typography
                variant="subtitle2"
                sx={{
                    fontWeight: 600,
                    color: "#424242",
                    mb: 1.5,
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                }}
            >
                <TableChart sx={{ fontSize: 18, color: "#1a8a9e" }} />
                Variable a consultar
            </Typography>

            <FormControl fullWidth>
                <Select
                    value={value}
                    onChange={(e) => onChange(e.target.value)}
                    displayEmpty
                    renderValue={() => {
                        if (!selectedTabla) return "Seleccionar variable";
                        return (
                            <Box
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 1.5,
                                    overflow: "hidden",
                                }}
                            >
                                <Box
                                    sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        width: 32,
                                        height: 32,
                                        borderRadius: 1,
                                        bgcolor: "#1a8a9e",
                                        color: "white",
                                        flexShrink: 0,
                                    }}
                                >
                                    {getIconForTable(selectedTabla.index)}
                                </Box>
                                <Box sx={{ overflow: "hidden" }}>
                                    <Typography
                                        variant="body2"
                                        sx={{ fontWeight: 600, color: "#2a8fa6", lineHeight: 1.2 }}
                                    >
                                        {selectedTabla.titulo}
                                    </Typography>
                                    <Typography
                                        variant="caption"
                                        sx={{
                                            color: "#757575",
                                            display: "block",
                                            lineHeight: 1.2,
                                            whiteSpace: "nowrap",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                        }}
                                    >
                                        {selectedTabla.descripcion}
                                    </Typography>
                                </Box>
                            </Box>
                        );
                    }}
                    sx={{
                        bgcolor: "white",
                        borderRadius: 2,
                        height: 56,
                        "& .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#e0e0e0",
                            borderWidth: 2,
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#80deea",
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#1a8a9e",
                        },
                        "& .MuiSelect-select": {
                            py: 1.5,
                            display: "flex",
                            alignItems: "center",
                        },
                    }}
                    MenuProps={{
                        PaperProps: {
                            sx: {
                                borderRadius: 2,
                                boxShadow: "0 8px 24px rgba(0,0,0,0.12)",
                                mt: 1,
                                maxHeight: 400,
                                "& .MuiMenuItem-root": {
                                    py: 1.5,
                                    px: 2,
                                    "&:hover": {
                                        bgcolor: "#f5f5f5",
                                    },
                                    "&.Mui-selected": {
                                        bgcolor: "#e0f7fa",
                                        "&:hover": {
                                            bgcolor: "#b2ebf2",
                                        },
                                    },
                                },
                            },
                        },
                    }}
                >
                    {tablasDisponibles.map((tabla) => (
                        <MenuItem key={tabla.index} value={tabla.index}>
                            <ListItemIcon
                                sx={{
                                    minWidth: 40,
                                    color:
                                        value === tabla.index
                                            ? "#1a8a9e"
                                            : "#757575",
                                }}
                            >
                                {getIconForTable(tabla.index)}
                            </ListItemIcon>
                            <ListItemText
                                primary={tabla.titulo}
                                secondary={tabla.descripcion}
                                primaryTypographyProps={{
                                    fontWeight: value === tabla.index ? 600 : 500,
                                    fontSize: "0.875rem",
                                    color:
                                        value === tabla.index
                                            ? "#2a8fa6"
                                            : "#424242",
                                }}
                                secondaryTypographyProps={{
                                    fontSize: "0.7rem",
                                    sx: {
                                        whiteSpace: "normal",
                                        lineHeight: 1.3,
                                        mt: 0.25,
                                    },
                                }}
                            />
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        </Box>
    );
};

export default SelectorTabla;
